// store.js
import { configureStore } from '@reduxjs/toolkit';  // Importamos la función de configureStore
import userReducer from './slices/userSlice';  // Importamos el reducer del userSlice
import sidebarReducer from './slices/sidebarSlice';  // Importamos el reducer del sidebarSlice
import formularioReducer from './slices/formularioSlice';
import darkModeSlice from "./slices/darkModeSlice"
import calendarReducer from "./slices/calendarSlice"
import podcastReducer from "./slices/podcastSlice"
import quizReducer from "./slices/quizSlice"
import votacionesReducer from "./slices/votacionesSlice"

// Creamos el store usando configureStore y agregamos el reducer del usuario
const store = configureStore({
  reducer: {
    user: userReducer,  
    sidebar: sidebarReducer,
    formulario: formularioReducer,
    darkMode: darkModeSlice,
    calendar: calendarReducer,
    podcast: podcastReducer,
    quiz: quizReducer,
    votaciones: votacionesReducer
  },
});

export default store;  // Exportamos el store para usarlo en toda la app
